import { myAxios } from "./axios"

export function getEmployees(data, { page, perPage }) {
    let config = {
        params: {
            page,
            perPage,
            ...(data || {}),
        },
    }
    return myAxios.get("/employees", config)
}

export function searchAndExport(data) {
    let config = {
        params: {
            filter: data
        },
    }
    return myAxios.get("/employees/export", config)
}

export function getEmployee(id) {
    return myAxios.get("/employees/" + id)
}

export function addEmployee(data) {
    return myAxios.post("/employees/create", data)
}

export function editEmployee(id, data) {
    return myAxios.put("/employees/" + id + "/update", data)
}

export function deleteEmployee(id) {
    return myAxios.delete("/employees/" + id + "/delete")
}

export function importEmployees(data) {
    return myAxios.post("/employees/import", data)
}

export function assignEmployeeToAdmin({data, empId}) {
    return myAxios.put('/employees/'+empId+'/admins/assign',data)
}

export function getEmployeeNotPaiedHours({empId}) {
    return myAxios.get('/employees/'+empId+'/hours/unpaid')
}
